import { render, staticRenderFns } from "./AlunosPerecer.vue?vue&type=template&id=13aab714&"
import script from "./AlunosPerecer.vue?vue&type=script&lang=js&"
export * from "./AlunosPerecer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports